import {Box, Typography, useTheme} from "@mui/material";
import {useIdentityAuth} from "../../context/IdentityAuthContext";
import BackButton from "../ui/BackButton";
import EnvironmentBadge from "../ui/EnvironmentBadge/EnvironmentBadge";
import UserAvatar from "../UserAvatar/UserAvatar";
import styles from "./Window.module.css";

const Window = ({title, topRightButtons, children, backTo}) => {
  const theme = useTheme();
  const {user} = useIdentityAuth();

  const entorno = process.env.REACT_APP_PANEL_ENVIRONMENT || "No especificado";
  const displayName = user?.name || null;

  return (
    <Box className={styles.container} style={{"--backgroundColor": theme.palette.windowScreen.background}}>
      <Box
        className={styles.header}
        style={{
          "--headerBackgroundColor": theme.palette.windowScreen.headerBackground
        }}
      >
        <Box sx={{display: "flex", alignItems: "center", gap: 1}}>
          {backTo && <BackButton fallbackRoute={backTo} />}
          <Typography variant="h3" fontWeight="bold" color={theme.palette.windowScreen.title}>
            {title}
          </Typography>
        </Box>

        <Box sx={{display: "flex", alignItems: "center", gap: 2}}>
          {topRightButtons && <Box className={styles.topRightButtons}>{topRightButtons}</Box>}
          <EnvironmentBadge environment={entorno} />
          <Box sx={{display: "flex", alignItems: "center", gap: 1}}>
            <UserAvatar name={displayName} size={32} />
            <Typography variant="body2" fontWeight="bold" color={theme.palette.windowScreen.title}>
              {displayName}
            </Typography>
          </Box>
        </Box>
      </Box>

      <Box className={styles.content}>{children}</Box>
    </Box>
  );
};

export default Window;
